import React from "react";
import { useState, useEffect } from "react";
import Navbar from "../../Components/Navbar";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useAuthContext } from "../../hooks";
import { CreateAccountSc } from "./index.sc";
import { addEmployeeWithPortalLogin } from "../../api/InsytixEmployees";
import { getOrgUserRoles } from "../../api/users/getOrgUserRoles";
import { getUsers } from "../../api/users/getUsers";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const Index = () => {
  const naviagte = useNavigate();
  const auth = useAuthContext();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const [reportsTo, SetReportsTo] = useState<any[]>([]);
  const [orgUserRoles, setOrgUserRoles] = useState<any[]>([]);
  const orgId = auth?.userInfo?.orgs?.[0]?.id || 100000000001;
  const fetchAllReportsTo = async () => {
    const rows = await getUsers(orgId);
    SetReportsTo(Array.isArray(rows) ? rows : []);
  };
  const fetchOrgUserRoles = async () => {
    const roles = await getOrgUserRoles(orgId);
    setOrgUserRoles(Array.isArray(roles) ? roles : []);
  };
  console.log(reportsTo);

  const handleCreate = async (e: any) => {
    const result = await addEmployeeWithPortalLogin(orgId, e);
    toast.success(result?.message || "User created");
  };

  const onSubmit = async (e: any) => {
    try {
      await handleCreate(e);
      reset();
      naviagte(`..`);
    } catch (err: any) {
      toast.error(err?.message || "Could not create the user");
    }
  };
  useEffect(() => {
    fetchAllReportsTo();
    fetchOrgUserRoles();
  }, []);

  console.log(orgUserRoles);
  console.log("reports to", reportsTo);
  return (
    <CreateAccountSc>
      <div className="form-container">
        <header>
          <h2>Create Account</h2>
          <p>
            This creates the Cognito login, emails a temporary password, and adds the person to the portal.
          </p>
        </header>
        <form className="create-user-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="form-field-container">
            <label htmlFor="first_name">First Name</label>
            <input
              type="text"
              id="first_name"
              placeholder="Enter your first name"
              className="form-input"
              {...register("first_name", {
                required: { value: true, message: "This is required" },
              })}
            />
          </div>
          <div className="form-field-container">
            <label htmlFor="last_name">Last Name</label>
            <input
              type="text"
              id="last_name"
              placeholder="Enter your last name"
              className="form-input"
              {...register("last_name", { required: true })}
            />
          </div>
          <div className="form-field-container">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              placeholder="Enter your Email Id"
              className="form-input"
              {...register("email", { required: true })}
            />
          </div>
          <div className="form-field-container">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="telephone"
              id="phone"
              placeholder="Enter your Phone Number"
              className="form-input"
              {...register("phone", { minLength: 10 })}
            />
          </div>
          <div className="org-user-role">
            <label>Role</label>
            <select
              id="org-role"
              className="org-roles"
              {...register("role_id", { required: true })}
            >
              <option value="">Select a role</option>
              {(Array.isArray(orgUserRoles) ? orgUserRoles : []).map((e, i) => {
                return (
                  <>
                    <option value={`${e?.role_id}`} key={i}>
                      {e?.role_name}
                    </option>
                  </>
                );
              })}
            </select>
          </div>
          <div className="form-field-container">
            <label>Reports To</label>
            <select
              id="role"
              className="form-input"
              {...register("leadOrgId")}
            >
              <option value="">Select a manager</option>
              {(Array.isArray(reportsTo) ? reportsTo : []).map((e, i) => {
                return (
                  <option value={`${e?.org_user_id}`} key={i}>
                    {`${e?.first_name || ""} ${e?.last_name || ""}`.trim()}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="btn-container">
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
    </CreateAccountSc>
  );
};

export default Index;
